import { Injectable } from "@angular/core";
import { ApiService } from "@edp-services/api.service";
import { LanguageService } from "@edp-services/language.service";
import moment from "moment";
@Injectable({
    providedIn: "root",
})
export class EdpTableV2Service {
    constructor(private apiService: ApiService, public languageService: LanguageService) {}

    public setDates(date: string, day?: boolean) {
        if (date === "-") {
            return date;
        }
        return day
            ? moment(date)
                  .locale(this.languageService.getLocale())
                  .format("DD MMM YYYY")
            : moment(date)
                  .locale(this.languageService.getLocale())
                  .format("MMM YYYY");
    }

    public longDescriptionFormat(desc: string) {
        if (desc.length > 23) {
            return desc.substring(0, 23) + "...";
        }
        return desc;
    }
}
